module.exports = __webpack_public_path__ + "static/media/funnel_description_en.ced17d2e.png";